import { useEffect, useState } from 'react'
import store from '../../utils/store'
import moment from 'moment'

const ResultsTable = () => {
    const [results, setResults] = useState<any>([])

    useEffect(() => {
        store.getFirebaseCollection('answers')
            .then(res => setResults(res))
    }, [])

    useEffect(() => {
        console.log(results)
    }, [results])

    return (
        <div className="body2 container-fluid">
        <h2>Resultados ({results.length})</h2>
        <table className='table table-striped table-bordered table-hover table-sm'>
            <thead className='thead-light'>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Barrio</th>
                    <th scope="col">Entre calle</th>
                    <th scope="col">y calle</th>
                    <th scope="col">Residencia</th>
                    <th scope="col">Motivo</th>
                    <th scope="col">Respuestas</th>
                </tr>
            </thead>
            <tbody>
                {results.map(
                    (result: any, index: any) => {
                     return (
                        <tr key={result.date}>
                            <th scope="row">{index+1}</th>
                            <td>{moment(parseInt(result.date)).format('DD/MM/YY HH:mm')}</td>
                            <td>{result.barrio}</td>
                            <td>{result.entrecalles.calle1}</td>
                            <td>{result.entrecalles.calle2}</td>
                            <td>{result.residencia}</td>
                            <td>{result.motivo}</td>
                            <td>
                                {Object.keys(result.answers).map(
                                    (key: string) => {
                                        return (
                                            <div key={key}>
                                                {key}: {result.answers[key]}
                                            </div>
                                    )}
                                )}
                                {/* {result.answers?.map((v: any, i: any) => {
                                    return (
                                        <div key={i}>
                                            {i}: {v}
                                        </div>)
                                })} */}
                            </td>
                        </tr>
                    )
                    })}
            </tbody>
        </table>
        </div>
    )
}

export default ResultsTable